import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2509f90c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "curriculum-edit-table-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_3 = { class: "rows" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurriculumEditTableRow = _resolveComponent("CurriculumEditTableRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
        return (_openBlock(), _createBlock(_component_CurriculumEditTableRow, {
          key: row.gradeNumber,
          class: "row",
          data: row,
          editing: _ctx.editing,
          "on-update": _ctx.onUpdateRow
        }, null, 8, ["data", "editing", "on-update"]))
      }), 128))
    ])
  ]))
}